<script lang="ts">
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";
    import type {ILicItem} from "../../interfaces/lic-item.interface";

    const dispatch = createEventDispatcher();

    export let data: ILicItem;
    export let isDisabled: boolean = false;

    function remove() {
        dispatch('remove')
    }
</script>
<tr>
    <td>
        <div>
            <input bind:value={data.number}
                   readonly={isDisabled || data?.disabled}
                   type="text"
                   class="naui-input"
                   style="width: 50px">
        </div>
    </td>
    <td>
        <div>
            <input bind:value={data.group}
                   readonly={isDisabled || data?.disabled}
                   type="text"
                   class="naui-input w-100"
                   style="width: 150px">
        </div>
    </td>
    <td>
        <div>
            <input bind:value={data.code}
                   readonly={isDisabled || data?.disabled}
                   type="text"
                   class="naui-input w-100"
                   style="width: 150px">
        </div>
    </td>
    <td>
        <div>
            <input bind:value={data.name}
                   readonly={isDisabled || data?.disabled}
                   type="text"
                   class="naui-input w-100">
        </div>
    </td>
    <td>
        <div>
            <input bind:value={data.quantity}
                   readonly={isDisabled || data?.disabled}
                   type="number"
                   class="naui-input w-100"
                   style="width: 150px">
        </div>
    </td>
    <td>
        <div>
            <input bind:value={data.roof}
                   readonly={isDisabled || data?.disabled}
                   type="number"
                   class="naui-input w-100"
                   style="width: 150px">
        </div>
    </td>
    <td>
        <div class="box">
            {#if !isDisabled}
                {#if !data.disabled}
                    <NauiButton icon="trash-alt"
                                color="accent"
                                on:click={remove}/>
                {/if}
            {/if}
        </div>
    </td>
</tr>